// extracted by mini-css-extract-plugin
export default {"container":"SuccessPage_container__SqKXG","inset":"SuccessPage_inset__O7dD3","title":"SuccessPage_title__v8aN6","text":"SuccessPage_text__Me7CI","image":"SuccessPage_image__OvzcU"};